enum FootTrafficFilterType {
  Locations = 'locations',
  Campaigns = 'campaigns',
  LineItems = 'lineItems',
}

export default FootTrafficFilterType;
